import { create } from 'zustand';
import { type PaperFormat } from '../api/gql/graphql';
import { type ScannerVariant } from '../pages/scanner/utils';
import { type UserError, type UserFlowType } from '../types/types';

/**
 * ScannerStore contains the detectedCountry, paper formats and scanner type.
 * It should net be persisted between sessions since it needs to
 * change if the current product changes.
 */
interface ScannerStore {
  paperFormat?: PaperFormat;
  flowType?: UserFlowType;
  blobs?: Blob[];
  reconstructionError?: UserError;
  scannerVariant?: ScannerVariant;
  disableCaptureValidation: boolean;
  setReconstructionError: (re: UserError | undefined) => void;
  setBlobs: (bl: Blob[]) => void;
  setPaperFormat: (pf: PaperFormat) => void;
  setFlowType: (ft: UserFlowType) => void;
  setScannerVariant: (sv: ScannerVariant) => void;
  setDisableCaptureValidation: (vc: boolean) => void;
}

export const useScannerStore = create<ScannerStore>((set) => ({
  paperFormat: undefined,
  flowType: undefined,
  blobs: undefined,
  reconstructionError: undefined,
  scannerVariant: undefined,
  disableCaptureValidation: false,
  setReconstructionError: (by) => {
    set(() => ({ reconstructionError: by }));
  },
  setBlobs: (by) => {
    set(() => ({ blobs: by }));
  },
  setPaperFormat: (by) => {
    set(() => ({ paperFormat: by }));
  },
  setFlowType: (by) => {
    set(() => ({ flowType: by }));
  },
  setScannerVariant: (by) => {
    set(() => ({ scannerVariant: by }));
  },
  setDisableCaptureValidation: (by) => {
    set(() => ({ disableCaptureValidation: by }));
  },
}));
